var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFolderOpenLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.87805 20.2C3.64518 20.2 3.42184 20.1052 3.25717 19.9364C3.09251 19.7676 3 19.5387 3 19.3V4.9C3 4.66131 3.09251 4.43239 3.25717 4.2636C3.42184 4.09482 3.64518 4 3.87805 4H10.3879L12.144 5.8H18.8049C19.0378 5.8 19.2611 5.89482 19.4258 6.0636C19.5904 6.23239 19.6829 6.46131 19.6829 6.7V9.4H17.9268V7.6H11.417L9.66088 5.8H4.7561V16.5982L6.07317 11.2H21L18.9717 19.5187C18.9241 19.7133 18.8145 19.8861 18.6602 20.0095C18.5059 20.1329 18.3157 20.2 18.12 20.2H3.87805ZM18.7504 13H7.44468L6.12761 18.4H17.4334L18.7504 13Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFolderOpenLine);
export default __webpack_public_path__ + "static/media/icon-folder-open-line.180120841216392d9eedfb842c25634d.svg";
export { ForwardRef as ReactComponent };